var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 120C93.1371 120 120 93.1371 120 60C120 26.8629 93.1371 0 60 0C26.8629 0 0 26.8629 0 60C0 93.1371 26.8629 120 60 120Z",
    fill: "url(#paint0_linear_3_6001)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8351 68.3423L46.9091 85.6917L49.076 87.6558L81.771 45.5101L79.5614 43.7915L39.1348 60L41.8351 68.3423Z",
    fill: "#6F79D4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3661 69.4883C56.9734 69.4883 50.0993 72.1069 50.0993 72.1069L48.8205 87.1537C48.7796 87.6328 49.3433 87.9182 49.7052 87.6016L61.1472 77.5898L57.3665 69.4883H57.3661Z",
    fill: "#4E57AA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4031 87.7472C81.9223 76.7362 87.6157 50.8917 90.0844 39.6635C90.5919 37.3544 88.3361 35.4032 86.124 36.2375L26.2167 58.839C23.9522 59.6935 24.058 62.9326 26.3734 63.6371L41.834 68.3425L77.105 45.5919C78.0354 44.9984 78.9355 46.0076 78.169 46.7376L50.0994 72.1068L73.9678 89.7589C75.9751 91.2434 78.8461 90.1809 79.4031 87.7472Z",
    fill: "#9292FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_6001",
    x1: -94.4483,
    y1: -177.607,
    x2: 195.339,
    y2: -94.0538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECF9FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperPlane);
export default __webpack_public_path__ + "static/media/paper-plane.d3b9e47c.svg";
export { ForwardRef as ReactComponent };